module.exports = __webpack_public_path__ + "img/goldregen-2020-075.652c90aa.jpg";